import * as types from "../actions/types";


const initialState = {
  current: null,
  list: [],
  loading: false,
};


export default function web_lessons (state = initialState, action) {
  switch (action.type) {
    case types.SET_WEB_LESSONS_CURRENT:
      return {
        ...state,
        current: action.payload
      };
    case types.SET_WEB_LESSONS_LIST:
      return {
        ...state,
        list: action.payload
      };
    case types.SET_WEB_LESSONS_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    default:
      return state;
  }
}